import React from 'react';
import { Check } from 'lucide-react';
import { useTranslation } from '../../lib/i18n';
import styles from './EveryPlanStacked.module.css';

/**
 * The blue band under the picker: eight things every plan includes, whichever card you buy.
 *
 * It answers the question the cards create. Each card lists what is DIFFERENT about its tier, which
 * leaves a reader comparing three short lists and wondering what the product actually is; this states
 * the floor once, so the cards can go on being a comparison.
 *
 * The eight lines are the same set the logged-out pricing page carries
 * (wix.com/symphony/pricing) — deliberately, because a visitor who read them there and then signed in
 * must not find a different product described.
 */

const ITEM_KEYS = [
  // Column order in the frame is ACROSS, not down: 1 and 2 are the first row, 3 and 4 the second.
  // A CSS grid fills the same way, so the array order is the reading order on both layouts.
  'pricing.stacked.item1',
  'pricing.stacked.item2',
  'pricing.stacked.item3',
  'pricing.stacked.item4',
  'pricing.stacked.item5',
  'pricing.stacked.item6',
  'pricing.stacked.item7',
  'pricing.stacked.item8',
] as const;

export function EveryPlanStacked() {
  const { t } = useTranslation();
  return (
    <section className={styles.band} aria-labelledby="sym-stacked-title">
      <div className={styles.card}>
        <h2 id="sym-stacked-title" className={styles.title}>
          {t('pricing.stacked.title')}
        </h2>
        <ul className={styles.list}>
          {ITEM_KEYS.map((key) => (
            <li key={key} className={styles.item}>
              <Check size={20} aria-hidden className={styles.check} />
              <span className={styles.itemText}>{t(key)}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
